import { useLocalStore } from 'mobx-react-lite';
import { useEffect } from 'react';

import { ICommonPopupsProps } from '@gem/popups';

import { IUserProfileInitiatorSource } from 'APP/main/Profile/UserProfile/UserProfile.presenter';
import Entities from 'STORE';
import { User } from 'STORE/Users/User/User';

export interface IUserProfilePopupParams {
  userId: string;
  initiatorSource?: IUserProfileInitiatorSource;
  hasBackButton?: boolean;
}

interface IUserProfilePopupPresenter {
  groupId: string;
  user: User | null;
  initialActiveGroup: string | null;
  isActiveGroupChanged: boolean;
  onClose(): void;
  onBack(): void;
}

export function useUserProfilePopupPresenter({
  params,
  onClose,
  onBack,
  popupInstance,
}: ICommonPopupsProps<IUserProfilePopupParams>): IUserProfilePopupPresenter {
  const { userId, hasBackButton = false } = params!;
  const presenter = useLocalStore<IUserProfilePopupPresenter>(() => ({
    initialActiveGroup: Entities.GroupsStore.activeGroupId,

    get user(): User | null {
      return Entities.usersStore.getUserById(userId);
    },

    get groupId(): string {
      return presenter.user?.group?.id || '';
    },

    get isActiveGroupChanged(): boolean {
      return presenter.initialActiveGroup !== Entities.GroupsStore.activeGroupId;
    },

    onClose(): void {
      popupInstance.close();
      onClose?.();
    },

    onBack(): void {
      if (!hasBackButton) {
        return;
      }

      popupInstance.close();
      onBack?.();
    },
  }));

  if (!presenter.user) {
    presenter.onClose();
  }

  useEffect(() => {
    if (presenter.isActiveGroupChanged) {
      presenter.onClose();
    }
  }, [presenter.isActiveGroupChanged]);

  return presenter;
}
